export default __webpack_public_path__ + "static/media/cinder.672e14d2.svg";